/** Société courante — localStorage. */

export const FX_COMPANY_KEY = "facturx_company_id";

export function readCompanyId(): number | null {
  try {
    const n = Number(localStorage.getItem(FX_COMPANY_KEY));
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

export function persistCompanyId(id: number): void {
  try {
    localStorage.setItem(FX_COMPANY_KEY, String(id));
  } catch {
    /* ignore */
  }
  announceFacturxCompany(id);
}

let companyAskInstalled = false;

export function announceFacturxCompany(id: number): void {
  if (!Number.isFinite(id) || id <= 0 || window.parent === window) return;
  window.parent.postMessage({ type: "aurelia:facturx-company", companyId: id }, "*");
}

export function listenFacturxCompanyAsk(): void {
  if (companyAskInstalled || window.parent === window) return;
  companyAskInstalled = true;
  window.addEventListener("message", (event: MessageEvent) => {
    const data = event.data as { type?: string } | null;
    if (!data || data.type !== "aurelia:facturx-company-ask" || event.source !== window.parent) return;
    const id = readCompanyId();
    if (id) announceFacturxCompany(id);
  });
}

export function clearCompanyId(): void {
  try {
    localStorage.removeItem(FX_COMPANY_KEY);
  } catch {
    /* ignore */
  }
}
